<section>
  <h1>{{'companyLogoAssociation.title'|translate}}</h1>
  <div class="content">
    <div>
    <app-img-display [uid]="company.uid" [type]="'companyLogo'" [imageTs]="logoTs" [hasBorder]="true"
      [reload]="logoTs"></app-img-display>
    <app-file-upload (userWantsUploadEvent)="onUserWantsUploadEvent($event)" text="uploadFile.chooseFileImage"
      uploadText="uploadFile.uploadFileImage" [backendResponse]="backendResponseUploadedFile"
      [isLoading]="isLoadingUpload" [fileType]="'IMAGES'" [hasStrictSize]="false">
    </app-file-upload>
    </div>
  </div>
</section>
